import { useLocation } from 'react-router-dom'

export const CHANNEL_ADD_REFERRER = {
  CAMPAIGN: 'CAMPAIGN',
  CREATIVE: 'CREATIVE',
  DOCUMENT: 'DOCUMENT',
}

const useChannelAddReferrer = () => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const from = params.get('from')
  return Object.values(CHANNEL_ADD_REFERRER).includes(from) ? from : null
}

export default useChannelAddReferrer
